import * as React from 'react'
import { Layout } from 'react-admin'
import AppBar from '../organisms/appBar'

// eslint-disable-next-line react/display-name
export default (props: any): JSX.Element => {
  return <Layout {...props} appBar={AppBar} />
}
